import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";

export type GroupType = "STATIC" | "DYNAMIC";

export interface GroupListItem {
  id: number;
  name?: string;
  type?: GroupType;
  status?: string;
}

interface UseGroupsListArgs {
  corporateId: string | number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useGroupsList = ({
  corporateId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseGroupsListArgs): PaginatedListResult<GroupListItem> => {
  const url = corporateId
    ? `${ServicesURL.groups.replace(
        ":idCorporate",
        String(corporateId),
      )}/groups`
    : null;

  return usePaginatedList<GroupListItem>(url, {
    page,
    pageSize,
    search,
    fieldFilters,
  });
};
